var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseCircleFilled = function SvgCloseCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8Zm2.85 11.85c-.25 0-.5-.1-.7-.3L8 9.4l-2.1 2.1c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4L6.6 8 4.5 5.9a.952.952 0 0 1-.25-.95c.1-.35.35-.6.7-.7.35-.1.7 0 .95.25L8 6.6l2.1-2.1c.25-.25.6-.35.95-.25.35.1.6.35.7.7.1.35 0 .7-.25.95L9.4 8l2.1 2.1c.2.2.3.45.3.7.05.6-.4 1.05-.95 1.05Z"
  })));
};
export default SvgCloseCircleFilled;